export default __webpack_public_path__ + "static/media/Warranty.66ecfa53.png";